import { Tooltip } from '@mantine/core'
import React from 'react'
import { getNodeStatusLabel, NODE_STATUS_COLORS } from '../Map/_utils/getActiveNodeStatus'
import { TNodeStatus } from '../types'

export const EQUIPMENT_COUNT_BADGE_CLASS = 'equipment-count-badge'

export const EquipmentCountBadge: React.FC<{ status: TNodeStatus; count?: number }> = ({ status, count }) => {
  const label =
    status === TNodeStatus.OFFLINE
      ? `${getNodeStatusLabel(TNodeStatus.OFFLINE)} + ${getNodeStatusLabel(TNodeStatus.PENDING)}`
      : getNodeStatusLabel(status)

  let countText = '-'

  if (count !== undefined) countText = count > 999 ? '999+' : count.toString()

  return (
    <Tooltip label={label}>
      <span
        className={EQUIPMENT_COUNT_BADGE_CLASS}
        css={{
          display: 'flex',
          color: 'black',
          backgroundColor: NODE_STATUS_COLORS[status],
          minWidth: 25,
          padding: '0 5px',
          height: 25,
          fontSize: '14px',
          borderRadius: 12.5,
          margin: '0 4px',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 'bold',
        }}
      >
        {countText}
      </span>
    </Tooltip>
  )
}
